import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ResetPassword.css';
import Notification from '../../components/Notification/Notification';
import publicAxios from '../../utils/axios/publicAxios';

const ResetPassword = () => {

  const token = localStorage.getItem('token');

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    otp: '',
    newPassword: '',
    confirmNewPassword: '',
  });

  const [notification, setNotification] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const { userId } = useParams();

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification({ type: '', message: '' });
    }, 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmNewPassword) {
      showNotification('error', 'Passwords do not match.');
      return;
    }

    try {
      setLoading(true);
      const { confirmNewPassword, ...dataToSend } = formData;
      const response = await publicAxios.post(`/public/reset-password/${userId}`, dataToSend);
      if (response.status === 200) {
        showNotification('success', response.data.message || 'Password reset successful!');
        setTimeout(() => {
          navigate(`/login`);
        }, 5000);
      }


      // Clear form
      setFormData({
        newPassword: '',
        confirmNewPassword: '',
        otp: '',
      });
    } catch (error) {
      console.error('Registration error:', error.response?.data || error.message);
      showNotification('error', error.response?.data?.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      navigate('/user-profile');
    }
  }, [token, navigate]);

  return (
    <div className="reset-password">

      <Notification
        type={notification.type}
        message={notification.message}
        onClose={() => setNotification({ type: '', message: '' })}
      />

      <form className="reset-password-form" onSubmit={handleSubmit}>
        <h2>Reset Password</h2>

        <div className="form-group">
          <div className='reset-password-otp-instruction'>Check your email for your OTP (<span>expires in 1 hour</span>)</div>
          <label>OTP:</label>
          <input
            type="text"
            name='otp'
            placeholder="Enter OTP"
            value={formData.otp}
            onChange={handleChange}
            required
          />
          <label>Password:</label>
          <input
            type="password"
            name="newPassword"
            placeholder="Enter new password"
            value={formData.newPassword}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Confirm Password:</label>
          <input
            type="password"
            name="confirmNewPassword"
            placeholder="Confirm new password"
            value={formData.confirmNewPassword}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="reset-password-btn" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;